export default function PriceSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const features = [
    { icon: 'ri-time-line', text: '毎月1回・60分の選べる作業' },
    { icon: 'ri-search-eye-line', text: '定期点検（屋根・外壁・水回り）' },
    { icon: 'ri-bug-line', text: '害虫駆除・予防処置' },
    { icon: 'ri-plant-line', text: '庭の草刈り・剪定' },
    { icon: 'ri-delete-bin-line', text: '室内外の清掃' },
    { icon: 'ri-tools-line', text: '小規模補修対応' },
    { icon: 'ri-chat-1-line', text: '写真付きLINE報告' },
    { icon: 'ri-phone-line', text: '緊急時の電話相談' },
  ];

  return (
    <section id="price" aria-label="料金プランのご案内" className="py-20 md:py-28 bg-stone-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-amber-700 text-sm font-semibold tracking-widest mb-3 uppercase">
            料金プラン
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-stone-800 leading-tight" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            シンプルな定額制で<br />安心の家管理を
          </h2>
          <p className="mt-4 text-stone-500 text-sm md:text-base max-w-xl mx-auto">
            複雑なオプション料金なし。月額定額で、家のことをまるごとおまかせいただけます。
          </p>
        </div>

        {/* Price Card */}
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-2xl overflow-hidden border border-stone-100">
            {/* Card Header */}
            <div className="bg-stone-800 px-8 py-8 text-center">
              <span className="inline-block bg-amber-500 text-white text-xs font-bold px-4 py-1 rounded-full mb-4">
                スタンダードプラン
              </span>
              <div className="flex items-end justify-center gap-1 mb-2">
                <span className="text-stone-300 text-lg">月額</span>
                <span className="text-white text-5xl md:text-6xl font-black">9,800</span>
                <span className="text-stone-300 text-lg mb-1">円</span>
                <span className="text-stone-400 text-sm mb-1">（税込）</span>
              </div>
              <p className="text-stone-300 text-sm">年間契約の場合 / 月払いも可能</p>
            </div>

            {/* Features */}
            <div className="px-8 py-8">
              <p className="text-stone-600 text-sm font-semibold mb-5">含まれるサービス</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {features.map((f) => (
                  <div key={f.text} className="flex items-center gap-3">
                    <div className="w-7 h-7 flex items-center justify-center bg-amber-50 rounded-full shrink-0">
                      <i className={`${f.icon} text-amber-600 text-sm`}></i>
                    </div>
                    <span className="text-stone-700 text-sm">{f.text}</span>
                  </div>
                ))}
              </div>

              {/* Note */}
              <div className="mt-6 bg-amber-50 rounded-lg p-4 border border-amber-100">
                <p className="text-amber-800 text-xs leading-relaxed">
                  <strong>※ 作業内容について：</strong>毎月1回60分の作業は、その月のご要望に合わせて選択いただけます。大規模な修繕工事は別途お見積もりとなります。
                </p>
              </div>

              {/* CTA */}
              <button
                onClick={() => scrollTo('contact')}
                className="cursor-pointer whitespace-nowrap w-full mt-6 bg-amber-600 hover:bg-amber-700 text-white font-bold py-4 rounded-full text-base transition-colors flex items-center justify-center gap-2"
              >
                <i className="ri-phone-line"></i>
                まずは無料相談・お見積もり
              </button>
              <p className="text-center text-stone-400 text-xs mt-3">
                相談・見積もりは完全無料です。しつこい営業は一切いたしません。
              </p>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-6 grid grid-cols-3 gap-3 text-center">
            {[
              { icon: 'ri-lock-line', text: '解約\nいつでも可' },
              { icon: 'ri-customer-service-2-line', text: '相談\n完全無料' },
              { icon: 'ri-shield-user-line', text: '損害\n保険加入済' },
            ].map((item) => (
              <div key={item.text} className="bg-white rounded-lg p-4 border border-stone-100">
                <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                  <i className={`${item.icon} text-amber-600 text-lg`}></i>
                </div>
                <p className="text-stone-600 text-xs font-semibold whitespace-pre-line leading-snug">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
